import React from 'react'
import {
    AppDownloadContentSectionMiddle,
    AppDownloadImageSection,
    AppDownloadSection,
    StyledAppDownloadImageMobile,
    StyledAppDownloadImageTablet,
    StyledAppDownloadImageWeb,
} from './TNAppDownloadSectionMiddle.styled'

export function TNAppDownloadSectionMiddle() {
    const theNightlyAppDownloadImageMobile = require<string>('./../assets/thenightly_app_download_image_1.png')
    const theNightlyAppDownloadImageTablet = require<string>('./../assets/thenightly_app_download_image_2.png')
    const theNightlyAppDownloadImageWeb = require<string>('./../assets/thenightly_app_download_image_3.png')

    return (
        <AppDownloadSection>
            <AppDownloadContentSectionMiddle>
                <AppDownloadImageSection>
                    <StyledAppDownloadImageMobile
                        src={theNightlyAppDownloadImageMobile}
                        alt="Download The Nightly Mobile App"
                    />
                    <StyledAppDownloadImageTablet
                        src={theNightlyAppDownloadImageTablet}
                        alt="Download The Nightly Mobile App"
                    />
                    <StyledAppDownloadImageWeb
                        src={theNightlyAppDownloadImageWeb}
                        alt="Download The Nightly Mobile App"
                    />
                </AppDownloadImageSection>
            </AppDownloadContentSectionMiddle>
        </AppDownloadSection>
    )
}
